import { z } from "zod"

const agreementSchema = z.object({
    id: z.string(),
    accepted_at: z.string().nullish(),
})

export type AgreementRest = z.infer<typeof agreementSchema>

export const agreementListSchema = z.object({
    items: z.array(agreementSchema)
})
